import { Button, Dialog, Image } from "@/components/Elements";
import useToggle from "@/hooks/useToggle";

export const DeleteButton = ({
  message,
  handleDelete,
}: {
  message: string;
  handleDelete: () => void;
}) => {
  const { show: showModal, toggle: toggleModal } = useToggle();

  const onDelete = () => {
    handleDelete();
    toggleModal();
  };

  return (
    <>
      <div onClick={toggleModal} className="w-[14px] h-[14px] cursor-pointer">
        <Image src="close.png" className="w-full h-full" />
      </div>
      {showModal && (
        <Dialog isOpen={showModal} onClose={toggleModal} hideHeader>
          <div className="flex justify-center">
            <div className="w-[100px] h-[100px]">
              <Image src="close.png" className="w-full h-full" />
            </div>
          </div>
          <div className="flex-1 mt-[20px] items-center">
            <div className="text-[22px] font-bold">Confirmation</div>
            <div className="text-[14px]">{message}</div>
            <div className="flex justify-between">
              <Button
                onClick={toggleModal}
                className="w-1/2 mt-[20px] bg-[#808080]"
              >
                <div className="self-center">Cancel</div>
              </Button>
              <Button onClick={onDelete} className="w-1/2 mt-[20px]">
                Yes
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};
